import { Box } from '@mui/material';
import { useAppContext } from 'app/AppContext';
import { useFormApi } from 'components/form';
import FormContent from 'components/form/FormContent';
import React, { createRef, useEffect } from 'react'
import { Form } from 'react-final-form';
import { useNavigate } from 'react-router-dom';
import { flog } from 'util/FileLogger';

export default function DefaultCrudForm({ title, routeForm, backRoute, initialValues, setNewValues, saveValues, validValues, formActions, contentProps, sxForm, children }) {

    const form = useFormApi();
    const formRef = createRef();


    useEffect(() => {
        if (form) {
            form.ref = formRef;
        }
    }, [form, formRef]);

    const { useSetTitle, setActionsView } = useAppContext();
    const navigate = useNavigate();



    // console.log('DefaultCrudForm Render')
    useEffect(() => {
        const actions = [];
        if (formActions) {
            if (formActions.novoForm) {
                //actions.push({
                //     uid: "novoForm",
                //     text: "Novo",
                //     iconName: "Add",
                //     sequence: "10",
                //     action: () => {

                //         setNewValues()
                //         form.reset()
                //         navigate("/" + routeForm);
                //     },
                // })

            }
            if (formActions.salvarForm) {
                actions.push({
                    uid: "salvarForm",
                    text: "Salvar",
                    iconName: "Check",
                    sequence: "20",
                    action: () => {
                        form.submit();
                    },
                })

            }

            if (formActions.sairForm) {
                actions.push({
                    uid: "sairForm",
                    text: "Sair",
                    iconName: "Close",
                    sequence: "999999",
                    action: () => {
                        flog(routeForm + " - close go back - " + backRoute)
                        // TODO: exibir diálogo de confirmação se o form estiver dirty.
                        if (backRoute) {

                            navigate("/" + backRoute);
                        } else {
                            navigate("/");

                        }
                    },
                })

            }



        }



        setActionsView(actions);

        return () => {
            setActionsView([]);
        };
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [backRoute, form, navigate, routeForm, setActionsView, setNewValues]);

    useSetTitle(title);

    async function handleSubmit(values) {
        let continueSave = true;
        if (validValues) {
            continueSave = await validValues(values)
        }
        if (continueSave) {
            if (saveValues) {
                console.log('vai salvar')
                saveValues(values)
            } else {
                console.log('sem metodo de salvamento')
            }
        }
    }
    // console.log('DefaultCrudForm initialValues', initialValues)
    return (
        <Box sx={sxForm || { flex: 1 }}>
            <Form onSubmit={handleSubmit} initialValues={initialValues} >
                {(formProps) => {
                    return (
                        <form ref={formRef} onSubmit={formProps.handleSubmit}>
                            <FormContent {...contentProps}>{children(formProps)}</FormContent>
                        </form>
                    );
                }}
            </Form>
        </Box>
    )
}